import { styled } from 'stitches.config'

export const RawFoodSubscriptionRoot = styled('div', {
  '& .d-only': {
    display: 'none',
  },
  '& .m-only': {
    display: 'block',
  },

  '@bp2': {
    '& .d-only': {
      display: 'block',
    },
    '& .m-only': {
      display: 'none',
    },
  },
})

export const BannerHeader = styled('h2', {
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  color: '$accent-white',
  textAlign: 'center',

  '@bp2': {
    fontSize: '$h2',
    letterSpacing: '$h2',
    lineHeight: '$h2',
  },
})

export const SignupHeader = styled(BannerHeader, {
  maxWidth: '300px',
  
  '@bp2': {
    fontSize: '$h1',
    letterSpacing: '$h1',
    lineHeight: '$h1',
    width: '100%',
    maxWidth: '1076px',
  },
})
